import axios from "axios";
import {
  GET_DOWNLOAD_SEND_REPORT,
  GET_DOWNLOAD_SEND_REPORT_DETAILS,
  POST_DOWNLOAD_SEND_REPORT,
  PUT_STATUS_DOWNLOAD_SEND_REPORT,
} from "..";

/**
 * reportDownloadSent list
 * @param {parameters} paramObj
 * @returns
 */

export const getDownloadSendReports = (paramObj) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(
    `${process.env.REACT_APP_API_URL}${GET_DOWNLOAD_SEND_REPORT}`,
    {
      headers: { Authorization: jwt_token },
      params: paramObj,
    }
  );
};

/**
 * create reportDownloadSent
 * @param {body} body
 * @returns
 */
export const postDownloadSendReports = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.post(
    `${process.env.REACT_APP_API_URL}${POST_DOWNLOAD_SEND_REPORT}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};

/**
 * update reportDownloadSent
 * @param {body} body
 * @returns
 */
export const putUpdateDownloadSendReports = (newData) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${POST_DOWNLOAD_SEND_REPORT}`,
    newData,
    {
      headers: { Authorization: jwt_token },
      params: { reportDownloadSentId: newData.id },
    }
  );
};

/**
 * delete reportDownloadSent
 * @param {id} reportDownloadSentId
 * @returns
 */
export const deleteDownloadSendReports = (reportDownloadSentId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.delete(
    `${process.env.REACT_APP_API_URL}${POST_DOWNLOAD_SEND_REPORT}`,
    {
      headers: { Authorization: jwt_token },
      params: { reportDownloadSentId: reportDownloadSentId },
    }
  );
};

/**
 * get reportDownloadSent details
 * @param {id} reportDownloadSentId
 * @returns
 */
export const getDownloadSendReportsDetails = (reportDownloadSentId) => {
  const jwt_token = localStorage.getItem("token");
  return axios.get(
    `${process.env.REACT_APP_API_URL}${GET_DOWNLOAD_SEND_REPORT_DETAILS}`,
    {
      headers: { Authorization: jwt_token },
      params: { reportDownloadSentId: reportDownloadSentId },
    }
  );
};

/**
 * enable-disable
 * @param {body} body
 * @returns
 */
export const updateStatusDownloadSendReports = (body) => {
  const jwt_token = localStorage.getItem("token");
  return axios.put(
    `${process.env.REACT_APP_API_URL}${PUT_STATUS_DOWNLOAD_SEND_REPORT}`,
    body,
    {
      headers: { Authorization: jwt_token },
    }
  );
};
